<div class="back-home">
  <button type="button" class="btn btn-sm pl-0 ml-0" [routerLink]="'../..'">
    <span><i class="icon icon-arrow-back-breadcrumb text-uppercase" aria-hidden="true"></i>Home</span>
  </button>
</div>
<div class="section-name col-sm-6 col-lg-12 p-0">
  All Storyboards
</div>

<app-storyboards [disableDrop]="true" [hideAddButton]="true" [hideModifyButton]="true"></app-storyboards>
